import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Icon, Tappable } from '@vectord/components';
import cogoToast from 'cogo-toast';

import { DEFAULT_ERROR_MESSAGE } from 'data/defaultErrorMessage';
import {
  bulkDeleteErrorMessageSelector,
  BULK_DELETE_SBAT_GROUP_MODAL_STAGES,
  resetSbatGroupBulkUpdate,
  sbatGroupBulkUpdateCommunicationsSelector,
  sbatGroupBulkUpdateReasonSelector,
  selectedBulkUpdateSbatGroupsSelector,
  setDeleteSbatGroupsModalStage,
  useBulkDeleteSbatGroupsMutation,
  VIEW_SCHEDULE_PAGE_TRACKINGS,
} from 'features/classCreation';
import analytics from 'utils/analytics';

export default function BulkDeleteSbatGroupModalConfirmStage() {
  const dispatch = useDispatch();
  const [bulkDeleteSbatGroup, { isSuccess, error, isLoading: isDeleting }] =
    useBulkDeleteSbatGroupsMutation();
  const selectedSbatGroups = useSelector(selectedBulkUpdateSbatGroupsSelector);
  const communications = useSelector(sbatGroupBulkUpdateCommunicationsSelector);
  const bulkDeleteReason = useSelector(sbatGroupBulkUpdateReasonSelector);
  const errorMessage = useSelector(bulkDeleteErrorMessageSelector);

  const handleCancel = useCallback(() => {
    dispatch(
      setDeleteSbatGroupsModalStage(BULK_DELETE_SBAT_GROUP_MODAL_STAGES.info)
    );
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetSbatGroupBulkUpdate());
      cogoToast.success('Selected classes are deleted successfully!');
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (error) {
      cogoToast.error(error.data?.message || DEFAULT_ERROR_MESSAGE);
    }
  }, [error]);

  const handleConfirm = useCallback(() => {
    const comms = Object.keys(communications).filter(
      (key) => communications[key]
    );
    const sbatGroupIds = Object.keys(selectedSbatGroups);

    analytics.click({
      click_type: VIEW_SCHEDULE_PAGE_TRACKINGS.bulkDeleteClasses,
      custom: {
        class_ids: sbatGroupIds,
        num_of_classes: sbatGroupIds.length,
        comms,
        reason: bulkDeleteReason?.label,
      },
    });

    bulkDeleteSbatGroup({
      sbatGroupIds: sbatGroupIds,
      reason: bulkDeleteReason?.label,
      comms,
    });
  }, [
    communications,
    bulkDeleteReason?.label,
    bulkDeleteSbatGroup,
    selectedSbatGroups,
  ]);

  return (
    <div className="column justify-c align-c">
      <div className="row">
        <Icon
          name="warning"
          className="h2 m-r-xxs danger"
        />
        <div className="dark h4 text-c m-b-m m-r-m">{errorMessage}</div>
      </div>
      <div>
        <Tappable
          className="btn btn-long btn-danger"
          onClick={handleConfirm}
          disabled={isDeleting}
        >
          Yes
        </Tappable>
        <Tappable
          className="btn btn-long m-l-xxs"
          onClick={handleCancel}
          disabled={isDeleting}
        >
          No
        </Tappable>
      </div>
    </div>
  );
}
